import React, { useRef, useState } from 'react';
import cx from 'classnames';

import { formatTel } from 'components/LoadDetail/SideRail/components/BookedLoad/BookedLoadHelpers';

import TextEntry from '@arrive/text-entry';

import { TRUCK_DRIVER_CHANGE_KEYS } from 'constants/truckDriverConstants';

import styles from './TruckAndDriverEntry.scss';

const notAlphanumericTest = /[^a-zA-Z0-9_ ]/;
const notAlphanumericSpecialTest = /[^\S ]/;
const notNumberTest = /\D/;

export const cleanTel = (stringToClean: string) => String(stringToClean || '').replace(/\+1|\D/g, '');
export const isValidInput = (inputVal: string, changeKey: string) => {
  if ((changeKey === TRUCK_DRIVER_CHANGE_KEYS.DRIVER_PHONE_NUMBER || changeKey === TRUCK_DRIVER_CHANGE_KEYS.SECOND_DRIVER_PHONE_NUMBER)) {
    return !notNumberTest.test(inputVal);
  } else if (changeKey === TRUCK_DRIVER_CHANGE_KEYS.TRUCK_NUMBER || changeKey === TRUCK_DRIVER_CHANGE_KEYS.TRAILER_NUMBER) {
    return !notAlphanumericSpecialTest.test(inputVal);
  }

  return !notAlphanumericTest.test(inputVal);
};

interface TextEntryProps {
  classes?: { container?: string, inputWrapper?: string };
  changeKey?: string;
  disabled?: boolean;
  required?: boolean;
  isEditActive?: boolean;
  setIsEditActive?: (a: boolean) => void;
  label: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onEdit?: () => void;
  useButtonPanel?: boolean;
  saveCallback?: (nextData: { [key: string]: string }) => Promise<boolean>;
  type?: 'string' | 'tel';
  value: string;
  theme?: 'roadhog' | 'ethanol'
  prohibitEditing?: boolean;
  phoneCode?: string;
}

// If useButtonPanel is TRUE, not intended to be used with an external on change.
export const TruckAndDriverTextEntry = ({ classes, disabled, required, label, onChange, type = 'string', value, theme = 'roadhog', phoneCode = '1' }: TextEntryProps) => {
  const [isBlur, setIsBlur] = useState(true);

  const inputRef = useRef<HTMLInputElement>();

  const handleTelValue = (currValue: string) => {
    if (isBlur) {
      return formatTel(currValue, phoneCode);
    }
    return cleanTel(currValue);
  };

  let testId
  if(label === 'Driver #1 Name' || label === 'Driver Name'){
    testId = "driverName"
  }else if(label === 'Driver 1 Phone' || label === 'Driver Phone'){
    testId = "driverPhoneNumber"
  }

  return (
    <TextEntry
      required={required}
      data-testid={testId}
      disabled={disabled}
      classes={{
        ...classes,
        container: cx(styles.truckDriverTextEntryContainer, { [styles.truckDriverTextEntryPhoneWrapper]: type === 'tel' }, classes?.container)
      }}
      label={label}
      maxLength={type === 'tel' ? 10 : 50}
      onBlur={() => setIsBlur(true)}
      onChange={onChange}
      onFocus={() => setIsBlur(false)}
      ref={inputRef}
      value={type === 'tel' ? handleTelValue(value) : value}
      theme={theme}
    />
  )
};

